import { render } from "./Deliveries.vue?vue&type=template&id=b5408d9a&scoped=true&ts=true"
import script from "./Deliveries.vue?vue&type=script&lang=ts"
export * from "./Deliveries.vue?vue&type=script&lang=ts"

import "./Deliveries.vue?vue&type=style&index=0&id=b5408d9a&lang=scss&scoped=true"

import exportComponent from "/builds/spark/services/frontend/admin-v2/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b5408d9a"]])

export default __exports__